<template>
  <PForm
    v-model="validado"
    @cancel="cancel"
    @accept="accept"
    :action="actionName"
    :textAction="textActionName"
    :textCancel="$t('label.cancelar')"
  >
    <template>
      <div>
        <PRow>
          <PCol>
            <PFormInputMultipleFile
              v-model="files"
              :label="`Fichero`"
              rules="required"
              accept=".xlsx, .csv, .zip"
            />
          </PCol>
        </PRow>
        <div class="fileFormat">
          <img
            :id="`infoFileFormat`"
            src="@/assets/icons/diferencia-icon.svg"
            alt="InfoFileFormat"
            class="icon-fileformat"
          />

          <b-tooltip :target="`infoFileFormat`" custom-class="table-cell-tooltip" placement="right">
            {{ $t("label.fileFormat") }} <b>{{ $t("label.fileFormatExt") }}</b>
            <br />
            {{ $t("label.fileType") }} <b>{{ $t("label.fileTypeExt") }}</b>
          </b-tooltip>
        </div>
      </div>
    </template>
  </PForm>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import Multiselect from "vue-multiselect";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VueMethods from "@/vue-methods";

@Component({
  name: "importar-form",
  mixins: [VueMethods],
  components: {
    Multiselect,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class ImportacionForm extends Vue {
  @Prop({ required: false }) actionName!: string;
  @Prop({ required: false }) textActionName!: string;

  files: File[] = [];

  validado = true;

  $refs!: {
    formImportar: InstanceType<typeof ValidationObserver>;
  };

  async accept(action: string): Promise<void> {
    if (action == "importar") {
      await this.importFile();
    }
  }

  async importFile(): Promise<void> {
    this.$emit("action", { action: "importacionConfirm", data: this.files });
  }

  cancel(): void {
    this.$emit("cancel");
  }
}
</script>

<style lang="scss" scoped>
.form_ImportarForm {
  padding: 1rem;
}
.btnDownload {
  margin-top: 26px;
  float: right;
}
.fileFormat {
  padding: 0.5rem 1rem;
  margin-bottom: 0.2rem;
}
.icon-fileformat {
  width: 30px;
  height: 30px;
}
</style>
